import { Skeleton } from "@/components/ui/skeleton";

const ProductDetailPageLoader = (): JSX.Element => {
  return (
    <section className=' space-y-6'>
      <div className='flex justify-between'>
        <Skeleton className=' h-16 w-[300px]' />
        <Skeleton className=' h-16 w-[600px]' />
      </div>
      <div className='flex items-center gap-4'>
        {Array.from({ length: 5 }, (_, index) => (
          <Skeleton key={index} className=' h-28 w-[200px]' />
        ))}
      </div>
      <div className='space-y-2'>
        <Skeleton className=' h-16 w-full' />
        <Skeleton className=' h-80 w-full' />
      </div>
    </section>
  );
};

export default ProductDetailPageLoader;
